module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_raiders.7ab36.png";